import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cardNumber',
  standalone: true
})
export class CardNumberPipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    if (!value) {
      return '';
    }
    value = value.replace(/ /g, '');
    let number;
    if (value.length <= 4) {
      number = value;
      return number;

    } else if (value.length <= 8 && value.length > 4) {
      number = value.substr(0, 4) + '-' +
        // number = value.substr(0, 4) + ' ' +
        value.substr(4);
      return number;
    } else if (value.length <= 12 && value.length > 8) {
      number = value.substr(0, 4) + '-' +
        // number = value.substr(0, 4) + ' ' +
        value.substr(4, 4) + '-' +
        // value.substr(4, 4) + ' ' +
        value.substr(8);
      return number;

    } else if (value.length > 12) {
      number = value.substr(0, 4) + '-' +
        // number = value.substr(0, 4) + ' ' +
        value.substr(4, 4) + '-' +
        // value.substr(4, 4) + ' ' +
        value.substr(8, 4) + '-' +
        // value.substr(8, 4) + ' ' +
        value.substr(12);
      return number;
    }
  }

}
